import './Community.css';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useSeo from '../../seo/useSeo';
import Header from '../../components/Header';
import Login from '../../components/Login';
import ChallengesTab from './ChallengesTab';
import TemplatesTab from './TemplatesTab';
import ToolsTab from './ToolsTab';

const SIDEBAR_ITEMS = [
  { id: 'challenges', labelKey: 'challenges.sidebarLabel' },
  { id: 'templates', labelKey: 'templates.sidebarLabel' },
  { id: 'tools', labelKey: 'common.toolsLabel' },
];
const SECTION_COMPONENTS = {
  challenges: ChallengesTab,
  tools: ToolsTab,
  templates: TemplatesTab,
};

function Community() {
  const { t } = useTranslation('community');
  useSeo({ page: 'community', path: '/community' });
  const [showLogin, setShowLogin] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [activeSection, setActiveSection] = useState('challenges');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleMenuClick = useCallback(() => {
    setShowPopup(true);
  }, []);

  const handleSidebarSelect = (id) => {
    setActiveSection(id);
    setSidebarOpen(false);
  };

  const ActiveSectionComponent = SECTION_COMPONENTS[activeSection];

  return (
    <>
      <Header
        onMenuClick={handleMenuClick}
        showPopup={showPopup}
        onClosePopup={() => setShowPopup(false)}
        onLoginClick={() => setShowLogin(true)}
      />

      <div className="community-page">
        <div className="community-shell">
          <button
            type="button"
            className="community-mobile-menu-btn"
            aria-label={t('common.openSideMenu')}
            onClick={() => setSidebarOpen(true)}
          >
            <span className="community-mobile-menu-icon" aria-hidden />
            {t('common.community')}
          </button>

          {sidebarOpen && (
            <button
              type="button"
              className="community-sidebar-backdrop"
              aria-label={t('common.closeMenu')}
              onClick={() => setSidebarOpen(false)}
            />
          )}

          <aside className={`community-sidebar ${sidebarOpen ? 'is-open' : ''}`}>
            <div className="community-sidebar-head">
              <span className="community-sidebar-title">{t('common.community')}</span>
              <button
                type="button"
                className="community-sidebar-close"
                aria-label={t('common.close')}
                onClick={() => setSidebarOpen(false)}
              >
                ×
              </button>
            </div>
            <nav className="community-sidebar-nav" aria-label={t('common.subMenuNav')}>
              {SIDEBAR_ITEMS.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`community-sidebar-link${activeSection === item.id ? ' is-active' : ''}`}
                  onClick={() => handleSidebarSelect(item.id)}
                >
                  {t(item.labelKey)}
                </button>
              ))}
            </nav>
          </aside>

          <main className="community-main">
            {ActiveSectionComponent ? (
              <ActiveSectionComponent onRequireLogin={() => setShowLogin(true)} />
            ) : null}
          </main>
        </div>
      </div>

      <Login isOpen={showLogin} onClose={() => setShowLogin(false)} />
    </>
  );
}

export default Community;
